import React from 'react';

export const MARKER_CFG = {
  eingang:    { label: 'Eingang',    icon: '→',  bg: '#dcfce7', border: '#16a34a', text: '#14532d', defaultW: 90,  defaultH: 36 },
  ausgang:    { label: 'Ausgang',    icon: '←',  bg: '#dbeafe', border: '#2563eb', text: '#1e3a8a', defaultW: 90,  defaultH: 36 },
  notausgang: { label: 'Notausgang', icon: '🚨', bg: '#fef2f2', border: '#dc2626', text: '#7f1d1d', defaultW: 110, defaultH: 36 },
  tuer:       { label: 'Tür',        icon: '🚪', bg: '#fef9c3', border: '#ca8a04', text: '#713f12', defaultW: 70,  defaultH: 36 },
  buehne:     { label: 'Bühne',      icon: '🎤', bg: '#f3e8ff', border: '#9333ea', text: '#3b0764', defaultW: 140, defaultH: 50 },
  wc:         { label: 'WC',         icon: '🚻', bg: '#e0f2fe', border: '#0284c7', text: '#0c4a6e', defaultW: 60,  defaultH: 36 },
  bar:        { label: 'Bar',        icon: '🍺', bg: '#fef3c7', border: '#d97706', text: '#78350f', defaultW: 80,  defaultH: 36 },
  info:       { label: 'Info',       icon: 'ℹ', bg: '#eff6ff', border: '#3b82f6', text: '#1e3a8a', defaultW: 60,  defaultH: 36 },
  wand:       { label: 'Wand',       icon: '▬',  bg: '#f1f5f9', border: '#64748b', text: '#1e293b', defaultW: 150, defaultH: 20 },
  strom:      { label: 'Strom',      icon: '⚡', bg: '#fefce8', border: '#eab308', text: '#713f12', defaultW: 70,  defaultH: 36 },
};

export default function SeatMapMarkerEl({ marker, dragging, onMouseDown, readonly = false }) {
  const cfg = MARKER_CFG[marker.type] || MARKER_CFG.info;
  const displayLabel = marker.label || cfg.label;

  return (
    <div
      onMouseDown={readonly ? undefined : (e) => onMouseDown?.(e, marker)}
      title={displayLabel}
      style={{
        position: 'absolute',
        left: Math.round(marker.pos_x),
        top:  Math.round(marker.pos_y),
        width:  marker.width,
        height: marker.height,
        background: cfg.bg,
        border: `2px solid ${cfg.border}`,
        borderRadius: marker.type === 'wand' ? 2 : 6,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 4,
        cursor: readonly ? 'default' : dragging ? 'grabbing' : 'grab',
        userSelect: 'none',
        zIndex: 5,
        boxSizing: 'border-box',
      }}
    >
      <span style={{ fontSize: marker.type === 'wand' ? '0px' : '0.85rem', lineHeight: 1 }}>{cfg.icon}</span>
      {marker.type !== 'wand' && (
        <span style={{ fontSize: '0.68rem', fontWeight: 700, color: cfg.text, whiteSpace: 'nowrap' }}>
          {displayLabel}
        </span>
      )}
    </div>
  );
}
